import { render, staticRenderFns } from "./FullScreenMessage .vue?vue&type=template&id=ce7b341a"
import script from "./FullScreenMessage .vue?vue&type=script&lang=js"
export * from "./FullScreenMessage .vue?vue&type=script&lang=js"
import style0 from "./FullScreenMessage .vue?vue&type=style&index=0&id=ce7b341a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports